import type { CaseHit } from './caseDetail';

export function isHitResolved(
  hit: Pick<CaseHit, 'verdict' | 'rawStatus' | 'whitelisted'>
): boolean {
  return (
    hit.verdict === 'false_positive' || hit.rawStatus === 'no_match' || Boolean(hit.whitelisted)
  );
}
